/**
 *  @deprecated reference RTK-generated tags instead
 */
export const TAG_TYPES = {
  HIGHLIGHTER: 'HighlighterAccounts',
  HIGHLIGHTER_ANSWER: 'HighlighterAnswers',
  HIGHLIGHTER_BOX: 'Boxes',
  HIGHLIGHTER_NOTE: 'HighlighterNotes',
  HIGHLIGHTER_TAG: 'HighlighterTags',
  HL_SURVEY: 'HighlighterSurveys',
  REFERRAL_CODE: 'ReferralCodes',
  SURVEY_INSTANCE: 'SurveyInstances',
  QUESTIONS: 'HighlighterQuestions',
} as const;
